import { PaletteVariantsEnum } from "../../../lss";
/**
 * Helper to apply the correct aria label to our icons
 */
var INFO = 'Info Icon';
var QUESTION = 'Question Icon';
export var getIconAriaLabel = function (palette) {
    if (palette === PaletteVariantsEnum.PRIMARY)
        return INFO;
    if (palette === PaletteVariantsEnum.SECONDARY)
        return QUESTION;
    return palette + " icon";
};
//# sourceMappingURL=getIconAriaLabel.js.map